// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

// `data-disable-with` is a feature of rails-ujs which is not available for links that are followed by
// unpoly. This macro will transform `data-disable-with` attributes to `up-disable-with` so they are treated
// in a similar way by our custom compiler.
up.macro('a[data-disable-with]', (link) => {
  const upAttribute = 'up-disable-with'
  const dataAttribute = 'data-disable-with'

  if (up.link.isFollowable(link)) {
    up.element.setMissingAttr(link, upAttribute, link.getAttribute(dataAttribute))
    // Remove the [data-...] attribute so links will not be
    // handled a second time by Rails UJS.
    link.removeAttribute(dataAttribute)
  }
})
